<!-- 重要事件数量统计 -->
<template>
  <div class="important_event">
    <div class="import_num">
      <div class="amount">
        <img
          class="import-icon"
          :src="require(isDefaultTheme ? '@/icon/home/video.png' : '@/icon/home/ic_video.png')"
          alt=""
        />

        <div class="equip_name">
          {{ $t('numberImportantVideos') }}
          <div class="num">{{ dataList.videoCount }}</div>
        </div>
        <div v-for="(item, index) of listData" :key="index" class="video-li">
          <div class="vedio-show">
            <img
              v-if="item.preMediaUrl === null"
              :src="isDefaultTheme ? coverSrcDefault : coverSrc"
              class="pic"
              :lazy="true"
              alt=""
            />
            <img v-if="item.preMediaUrl !== null" :src="item.preMediaUrl" class="pic" :lazy="true" alt="" />
            <img src="@/icon/new-common/icon_play.png" class="play-icon" />
          </div>
        </div>
        <img
          :src="require(isDefaultTheme ? '@/icon/home/ic_arrow.png' : '@/icon/home/turn_arrow.png')"
          v-if="listData.length >= 2"
          @click="handleMore"
          class="more-icon"
        />
      </div>
      <div class="amount">
        <img
          class="import-icon"
          :src="require(isDefaultTheme ? '@/icon/home/pic.png' : '@/icon/home/ic_pic.png')"
          alt=""
        />

        <div class="equip_name">
          {{ $t('numberImportantPictures') }}
          <div class="num">{{ dataList.photoCount }}</div>
        </div>
        <div v-for="(item, index) of imageList" :key="index" class="video-li">
          <div class="vedio-show">
            <el-image :src="item.mediaUrl" :title="item.location" class="pic"> </el-image>
          </div>
        </div>
        <img
          :src="require(isDefaultTheme ? '@/icon/home/ic_arrow.png' : '@/icon/home/turn_arrow.png')"
          v-if="imageList.length >= 2"
          @click="handleMore"
          class="more-icon"
        />
      </div>
      <div class="amount">
        <img
          class="import-icon"
          :src="require(isDefaultTheme ? '@/icon/home/trajectory.png' : '@/icon/home/ic_trajectory.png')"
          alt=""
        />

        <div class="equip_name">
          {{ $t('numberImportantTracks') }}
          <div class="num">{{ dataList.gpsCount }}</div>
        </div>
        <div v-for="(item, index) of gpsList" :key="index" class="video-li">
          <div class="vedio-show">
            <img src="@/icon/home/ic_dingwei.png" class="gps-icon" />
            {{ item.userName }}
          </div>
        </div>
        <img
          :src="require(isDefaultTheme ? '@/icon/home/ic_arrow.png' : '@/icon/home/turn_arrow.png')"
          v-if="dataList.gpsCount >= 2"
          @click="handleMore"
          class="more-icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getImportantVideo, getImportantPhoto } from '@/api/new-focus/index.js'
import { listGps } from '@/api/log/log'
export default {
  props: {
    currenNode: {
      type: [Object, Array],
    },
  },
  data() {
    return {
      dataList: { gpsCount: 0, photoCount: 0, videoCount: 0 },
      listData: [], // 重要视频集合
      searchForm: {
        userId: '',
        description: '', // 备注
        appName: '', // 应用程序
        logTimestampBegin: '', // 开始日期
        logTimestampEnd: '', // 结束日期
        importantFlag: true,
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      imageList: [],
      coverSrc: require('@/icon/monitor/coverPlaceDark.png'),
      coverSrcDefault: require('@/icon/monitor/coverPlaceLight.png'),
      gpsList: [],
    }
  },
  methods: {
    handleMore() {
      this.$router.push({ path: '/newIndex/newFocus' })
      this.$store.commit('currentIndex', 'focus')
    },
    getVideoPage() {
      // 重要视频
      let videoSearch = Object.assign({}, this.searchForm)
      videoSearch.logTimestampBegin = this.currenNode.startTime
      videoSearch.logTimestampEnd = this.currenNode.endTime
      videoSearch.groupActual = 1
      getImportantVideo(videoSearch).then(res => {
        if (res.value && res.value.list) {
          this.listData = res.value.list
          if (res.value.list.length >= 2) {
            this.listData = res.value.list.slice(0, 2)
          }
          this.dataList.videoCount = res.value.total ? res.value.total : 0
        }
      })
    },
    getPhotoPage() {
      // 重要图片
      let photoSearch = Object.assign({}, this.searchForm)
      photoSearch.logTimestampBegin = this.currenNode.startTime
      photoSearch.logTimestampEnd = this.currenNode.endTime
      getImportantPhoto(photoSearch).then(res => {
        this.imageList = res.value && res.value.list ? res.value.list : []
        if (res.value.list.length >= 2) {
          this.imageList = res.value.list.slice(0, 2)
        }
        this.dataList.photoCount = res.value.total ? res.value.total : 0
      })
    },
    getGpsPage() {
      // 重要轨迹
      let gpsSearch = Object.assign({}, this.searchForm)
      gpsSearch.logTimestampBegin = this.currenNode.startTime
      gpsSearch.logTimestampEnd = this.currenNode.endTime
      listGps(gpsSearch).then(res => {
        this.gpsList = res.value && res.value.list ? res.value.list : []
        if (res.value.list.length >= 2) {
          this.gpsList = res.value.list.slice(0, 2)
        }
        this.dataList.gpsCount = res.value.total ? res.value.total : 0
      })
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
  watch: {
    currenNode: {
      handler() {
        this.getVideoPage()
        this.getPhotoPage()
        this.getGpsPage()
      },
      deep: true,
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.important_event
  pointer-events: auto
  height: calc(100% - 60px)
  .import_num
    width 96%
    height: 96%
    margin-left 20px
    margin-top 10px
    .amount
      width: 91%;
      height: 23%;
      padding: 10px
      margin-top 10px
      border: 1px solid #94DAFF;
      background: linear-gradient(90deg, #FFFFFF 0%, #E7F5FF 100%);
      border-radius: 4px;
      display: flex
      align-items: center
      font-size: 20px;
      .video-li
        margin-left: 10px
      .vedio-show
        position relative
        height 70px
        width: 70px
        background: #0B85F0;
        border-radius 4px
        overflow hidden
        font-size: 12px;
        color: #00DEFF
        text-align: center
        .gps-icon
          display: block
          width 34px
          height 34px
          margin: 5px auto
        .pic
          width: 100%;
          height: 100%
        .play-icon
          position absolute
          top 50%
          left 50%
          width 24px
          height 24px
          transform translate(-50%, -50%)
      .more-icon
        width 16px
        height 16px
        margin-left: 10px
        cursor pointer
      .import-icon
        width: 50px
        height: 50px
        margin-right: 20px
      .num
        font-size: 34px;
        font-weight: bold;
        color: #49C5FF;
        line-height: 40px;
        text-shadow: 0px 4px 0px rgba(4,244,254,0.3);
        background: linear-gradient(0deg, #5155DF 0%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image:-webkit-linear-gradient(bottom,#5155DF,#04F4FE);
      .equip_name
        margin-top 10px
        color #333
        font-size: 16px
        font-weight: bold
        margin-right: 40px
.theme-dark
  .important_event
    .video-li
      .vedio-show
        background: #0B85F0;
    .import_num
      .amount
        border: 1px solid #0E65DD;
        background: #002072;
        .equip_name
          color #fff
</style>
